import ReviewCard from '../review-card';

const reviews = [
    {
        id: 0,
        avatarUrl: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=56&h=56&fit=crop&q=80',
        name: 'Alena',
        rating: 4,
        date: 'July 2025',
        reviewText:
        'Beautiful views inside and out. Wake up and smell the coffee while enjoying the scenic front and back yard. Close to bike trails, kid friendly home with lots of space for family quality time.',
    },
    {
        id: 1,
        avatarUrl: 'https://images.unsplash.com/photo-1531427186611-ecfd6d936c79?w=56&h=56&fit=crop&q=80',
        name: 'Antonio',
        rating: 5,
        date: 'August 2025',
        reviewText: 'Very nice house. No complaints at all, was a great stay',
    },
    {
        id: 2,
        avatarUrl: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=56&h=56&fit=crop&q=80',
        name: 'Alana',
        rating: 5,
        date: 'September 2025',
        reviewText:
        'We had 6 adults/6 kids and this house exceeded our expectations and accommodated all of us perfectly. Lots of games and space to run outside for the kids and plenty of sleeping arrangements/ places to sit for the adults. We utilized the outdoor area just as much as inside and had a great time. The lakes are very close by, too. Overall 10/10 experience we are already talking about staying here again!',
    },
    {
        id: 3,
        avatarUrl: 'https://images.unsplash.com/photo-1531427186611-ecfd6d936c79?w=56&h=56&fit=crop&q=8',
        name: 'Justin',
        rating: 5,
        date: 'September 2025',
        reviewText:
        'The house was amazing and the host was extremely responsive and flexible during our stay. Absolutely recommend!',
    },
];

export default function ReviewsTab() {
    return (
        <div className="">
            <h2 className="font-bold text-4xl mb-4">Guest Reviews</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
                {reviews.map((review) => (
                    <ReviewCard
                        key={review.id}
                        avatarUrl={review.avatarUrl}
                        name={review.name}
                        rating={review.rating}
                        date={review.date}
                        reviewText={review.reviewText}
                    />
                ))}
            </div>
        </div>
    );
}